define('app/sdc/social/sdc-social',[],function () {
	var iconClass = "btn-social-icon";
	var normalClass = "btn-social";
	return {
		transclude: true,
		controller: {
			bind: {
				"type": "@"
			},
			prototype: {
				typeFontAwesome: function () {
					switch (this.type) {
						case "microsoft":
							return "windows";
						default:
							return this.type;
					}
				}
			},
			constructor: ["$watch", "$attrs", "$transclude", function ($watch, $attrs, $transclude) {
				var oldType;
				$attrs.$addClass("btn");
				function setAsIcon(isIcon) {
					$attrs.$removeClass(isIcon ? normalClass : iconClass);
					$attrs.$addClass(isIcon ? iconClass : normalClass);
				}
				$attrs.$observe("vm.type", function (newType) {
					$attrs.$addClass("btn-" + newType);
					if (oldType) {
						$attrs.$removeClass("btn-" + oldType);
					}
					oldType = newType;
				});
				$transclude(function (clone) {
					setAsIcon(!clone.length);
				});
			}]
		}
	}
});
